import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SearchBar from '../SearchBar/SearchBar';
import RecentPoems from '../RecentPoems/RecentPoems';
import { useReadingHistory } from '../../contexts/ReadingHistoryContext';
import { getAllCatalogs } from '../../services/poetryService';
import {xCycles, xPoets} from "../../utils/Lang";

const HomePage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { recentPoems } = useReadingHistory();
  const navigate = useNavigate();
  const catalogs = getAllCatalogs();

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
    if (query.trim()) {
      navigate(`/search?q=${encodeURIComponent(query)}`);
    }
  };

  return (
    <div className="home">
      <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        className="home__feather-icon"
      >
        <path d="M 2.01 19.32 C 1.276 21.102 0.284 22.794 0 24.576 l 1.026 -0.088 c 1.62 -4.712 3.08 -7.88 6.246 -11.842 C 9.648 9.678 12.226 7.316 15.532 5.44 c 1.76 -1 4.014 -2.094 6.042 -2.37 c 0.554 -0.076 1.116 -0.098 1.692 -0.048 c -6.28 1.438 -11.252 4.768 -15.224 9.76 C 6.42 14.818 5.01 17.08 3.714 19.464 l 2.388 0.436 l -0.994 -0.494 l 3.556 -0.566 c -1.32 -0.466 -2.624 -0.31 -3.042 -0.812 c 3.66 -0.166 6.668 -0.956 8.78 -2.49 c -0.786 -0.11 -1.692 -0.208 -2.164 -0.434 c 3.538 -1.196 5.584 -3.346 8.18 -5.254 c -3.374 0.708 -6.496 0.592 -7.4 -0.05 c 5.954 0.442 9.8 -1.204 11.118 -5.354 c 0.114 -0.448 0.146 -0.9 0.074 -1.356 C 23.748 0.124 18.498 -0.878 16.79 1.554 c -0.342 0.486 -0.824 0.932 -1.222 1.496 L 17.194 0 c -4.376 1.478 -4.736 3.108 -7 8.018 c 0.18 -1.494 0.594 -2.848 1.132 -4.126 c -5.468 2.11 -7.29 7.422 -7.582 11.94 c -0.158 -1.576 0.134 -3.556 0.698 -5.78 c -1.596 1.6 -2.682 3.478 -2.294 6.158 l -0.73 -0.326 l 0.384 1.438 l -1.092 -0.518 L 2.01 19.32 L 2.01 19.32 z"/>
      </svg>
      <h1 className="home__title">Поезија на српском</h1>
      <p className="home__subtitle">Лепо читање класичне и савремене поезије</p>

      <div className="home__search">
        <SearchBar
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Претражи песме, песнике..."
        />
      </div>


      <section className="home__section">
        <h2 className="home__section-title">Прегледај каталоге</h2>
        <ul className="catalog-list__items">
          {catalogs.map(catalog => (
            <li key={catalog.id}>
              <Link to={`/catalog/${catalog.id}`} className="catalog-list__item">
                {catalog.name}
                <span className="catalog-list__item-count">
                  ({catalog.poets.length} {catalog.type === "cycles" ? xCycles(catalog.poets.length) : xPoets(catalog.poets.length)})
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      {recentPoems.length > 0 && (
        <section className="home__section">
          <h2 className="home__section-title">Недавно читано</h2>
          <RecentPoems />
        </section>
      )}
    </div>
  );
};

export default HomePage;

